














































import A from '@/utilities/alpha'
import AssetAccordion from './AssetAccordion.vue'
import PrototypesList from './PrototypesList.vue'
import ToggleSwitch from './ToggleSwitch.vue'
import Redactor from '../Redactor.vue'
import AudienceInfo from '../AudienceInfo.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: {
    AssetAccordion,
    PrototypesList,
    ToggleSwitch,
    Redactor,
    AudienceInfo
  }
})
export default class CardDisplay extends Vue {
  @Prop() drop!:any
  @Prop() additionalClasses!:any
  @Prop() idx!:any
  @Prop({ default: false }) editable!:boolean
  @Prop() reportType!:number
  @Prop({ required: false }) parentIdx!:number
  @Prop({ required: true }) displayOrder!:number

  qualNotable:any = this.drop.payload.qualNotable || []

  get assets ():any {
    if (!this.drop.payload.assets) {
      return {}
    }
    return this.drop.payload.assets
  }

  get prototypes ():any {
    return this.drop.payload.prototypes || {}
  }

  get extraClasses ():any {
    var classes = ''
    if (this.additionalClasses) {
      classes += this.additionalClasses
    }
    if (this.editable) {
      classes += ' editable'
    }
    if (!this.drop.export) {
      classes += ' nonExport'
    }
    return classes
  }

  get answer ():any {
    var ans = this.drop.payload.answer
    if (!this.editable && !A.stripHTML(ans).trim()) {
      return false
    } else {
      return ans
    }
  }

  get shouldShow ():any {
    // eslint-disable-next-line no-prototype-builtins
    return this.editable || (this.drop.hasOwnProperty('export') && this.drop.export) || (!this.drop.hasOwnProperty('export') && !this.drop.nonExport) // backwards compatibility
  }

  get audienceObject ():any {
    if (typeof this.drop.payload.segment === 'object') {
      return this.drop.payload.segment
    } else if (this.drop.payload.formatted_segment) {
      return this.drop.payload.formatted_segment
    } else {
      return false
    }
  }

  moveAsset (ops:any) {
    var index = ops.index
    var asset = this.drop.assetOrder[index]
    var newIndex = ops.direction === 'up' ? index - 1 : index + 1
    var swapAsset = ops.direction === 'up' ? this.drop.assetOrder[newIndex] : this.drop.assetOrder[newIndex]
    var order = A.clone(this.drop.assetOrder)
    order[newIndex] = asset
    order[index] = swapAsset
    this.$set(this.drop, 'assetOrder', order)
  }

  clickAsset (asset:any) {
    this.$emit('clickAsset', asset)
  }

  updateAsset ({ asset, key }:any) {
    this.$emit('updateAsset', { asset, key })
  }
}
